import { useState, useEffect, useCallback } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { Palmtree } from "lucide-react";
import { Link } from "react-router-dom";

const HolidayModeBanner = () => {
  const { user } = useAuth();
  const [holidayMode, setHolidayMode] = useState(false);

  const checkHoliday = useCallback(async () => {
    if (!user) {
      setHolidayMode(false);
      return;
    }
    const { data } = await supabase
      .from("profiles")
      .select("holiday_mode")
      .eq("id", user.id)
      .single();
    setHolidayMode((data as any)?.holiday_mode === true);
  }, [user]);

  useEffect(() => {
    checkHoliday();
    if (!user) return;

    const channel = supabase
      .channel(`holiday-banner-${user.id}`)
      .on("postgres_changes", {
        event: "UPDATE",
        schema: "public",
        table: "profiles",
        filter: `id=eq.${user.id}`,
      }, (payload) => {
        setHolidayMode((payload.new as any).holiday_mode === true);
      })
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [user, checkHoliday]);

  if (!holidayMode) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-amber/20 border-b border-amber/30 backdrop-blur-sm">
      <div className="container mx-auto px-4 flex items-center justify-center h-10 text-sm font-medium gap-2 text-foreground">
        <Palmtree className="h-4 w-4" />
        <span>You're in Holiday Mode — you're hidden from the marketplace.</span>
        <Link to="/profile" className="underline underline-offset-2 font-semibold hover:text-amber">
          Turn off
        </Link>
      </div>
    </div>
  );
};

export default HolidayModeBanner;
